
import { Profile } from "@/types/database.types";
import { Badge } from "@/components/ui/badge";

interface UserHeaderProps {
  user: Profile;
  isAdmin: boolean;
  getInitials: (firstName?: string | null, lastName?: string | null) => string;
}

export const UserHeader = ({ user, isAdmin, getInitials }: UserHeaderProps) => {
  return (
    <div className="flex items-center justify-between p-4 bg-gradient-to-r from-gray-50 to-white border-b">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-primary text-primary-foreground shadow-sm">
          {getInitials(user.first_name, user.last_name)}
        </div>
        <div>
          <h3 className="font-medium flex items-center">
            {user.first_name || ''} {user.last_name || ''}
            {isAdmin && (
              <Badge variant="glass-primary" className="ml-2">
                Admin
              </Badge>
            )}
            {!user.first_name && !user.last_name && (
              <span className="text-muted-foreground">No Name</span>
            )}
          </h3>
          <p className="text-sm text-muted-foreground">{user.email}</p>
        </div>
      </div>
    </div>
  );
};
